export const enum NoticeTypeEnum {
	INFO = 'info',
	ERROR = 'error',
	WARNING = 'warning',
	SUCCESS = 'success',
}

export type NoticeDto = {
	NoticeType: NoticeTypeEnum,
	TextList: string[],
};

export type NoticeViewDto = {
	NoticeType: NoticeTypeEnum,
	Title: string | null,
	Lines: string[],
};
